import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'KeyboardOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-keyboard-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 18h-14a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2m4 0h10a2 2 0 0 1 2 2v8c0 .554 -.226 1.056 -.59 1.418"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 10l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 10l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 10l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 10l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 14l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 14l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 14l4 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 3l18 18"
    }, null), _createTextVNode(" ")]);
  }
};